import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(e.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="absolute inset-0 bg-gradient-to-br from-[#ff6a2b]/10 via-black to-[#2ec9a8]/10 pointer-events-none" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-neutral-950/80 backdrop-blur-md p-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="relative w-11 h-11 rounded-full flex items-center justify-center overflow-hidden">
            <span className="absolute inset-0 bg-gradient-to-br from-[#ff8a3c] via-[#ff6a2b] to-[#2ec9a8]" />
            <span className="relative text-black font-black text-lg font-display">K</span>
          </span>
          <div>
            <div className="font-heading text-2xl tracking-[0.15em]">KILOMBO</div>
            <div className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50">CMS Admin</div>
          </div>
        </div>

        <h1 className="font-display text-3xl mb-2">Iniciar sesión</h1>
        <p className="text-white/60 text-sm mb-8">Accede al panel de administración de contenido.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50 mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full bg-black/60 border border-white/10 focus:border-[#ff8a3c] focus:outline-none rounded-xl pl-10 pr-4 py-3 text-white placeholder:text-white/30 transition-colors" placeholder="admin@kilombo.com.co" />
            </div>
          </div>
          <div>
            <label className="block font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50 mb-2">Contraseña</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full bg-black/60 border border-white/10 focus:border-[#ff8a3c] focus:outline-none rounded-xl pl-10 pr-4 py-3 text-white placeholder:text-white/30 transition-colors" placeholder="••••••••" />
            </div>
          </div>

          {err && (
            <div className="rounded-xl border border-red-500/30 bg-red-500/10 text-red-300 text-sm px-4 py-3">
              {err}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-shine w-full mt-4 rounded-full bg-white text-black py-3.5 font-mono-caps text-xs tracking-[0.2em] uppercase hover:bg-neutral-100 transition-colors disabled:opacity-60">
            {loading ? "Entrando..." : "Iniciar sesión"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="font-mono-caps text-xs tracking-[0.2em] uppercase text-white/40 hover:text-white transition-colors">← Volver al sitio</a>
        </div>
      </div>
    </div>
  );
}
